<template>
  <chart :options="options" :height="chartHeight" :on="events" />
</template>

<script>
import Chart from '@/components/echarts'

export default {
  name: 'LiveChart',
  components: { Chart },
  props: {
    chartData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      chartHeight: '',
      options: {}
    }
  },
  computed: {
    events() {
      return [
        {
          name: 'legendselectchanged',
          method: () => {
            this.options.legend.selected.inc = !this.options.legend.selected.inc
            this.options.legend.selected.total = !this.options.legend.selected.total
          }
        }
      ]
    }
  },
  watch: {
    chartData: {
      handler(data) {
        this.chartHeight = (data.time.length * 30).toString() + 'px'

        this.options = {
          title: {
            text: '报名人数'
          },
          legend: {
            data: ['inc', 'total'],
            selected: {
              'inc': false,
              'total': true
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          xAxis: [
            {
              type: 'value'
            }
          ],
          yAxis: {
            type: 'category',
            axisTick: {
              show: true
            },
            data: data.time
          },
          series: [
            {
              name: 'inc',
              type: 'bar',
              stack: '总量',
              label: {
                show: true
              },
              data: data.inc
            },
            {
              name: 'total',
              type: 'bar',
              stack: '总量',
              label: {
                show: true
              },
              data: data.total
            }
          ]
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
